import { Link } from "react-router-dom";
import { Eyebrow } from "@/components/shared";
import { Server, ArrowRight, Check } from "lucide-react";

export default function ProxmoxBackup() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8">
      <Eyebrow>Proxmox Backup</Eyebrow>
      <h1 className="max-w-3xl font-display text-4xl font-extrabold tracking-tight text-slate-50 sm:text-5xl">A native Proxmox Backup Server, managed for you.</h1>
      <p className="mt-4 max-w-2xl text-slate-400">ZettaKeep runs the current stable Proxmox Backup Server 4.x release. It behaves exactly like a PBS you'd run yourself — because it is one. We just handle the infrastructure, patching, monitoring and storage.</p>

      <div className="mt-12 grid gap-6 lg:grid-cols-2">
        <div className="rounded-2xl border border-slate-800 bg-slate-900/40 p-8">
          <Server className="h-7 w-7 text-cyan-400" />
          <h2 className="mt-4 font-display text-xl font-bold text-slate-100">What we provision automatically</h2>
          <ul className="mt-4 space-y-2.5">
            {["Compute + hostname + DNS", "OS patching + PBS 4.x install", "Datastore + storage configuration", "Customer API token", "Firewall (default deny) + TLS", "Monitoring, pruning, GC & verification", "Notifications + health check", "Registration with the control plane"].map((f) => (
              <li key={f} className="flex items-start gap-2 text-sm text-slate-300"><Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" /> {f}</li>
            ))}
          </ul>
        </div>
        <div className="rounded-2xl border border-slate-800 bg-slate-900/40 p-8">
          <h2 className="font-display text-xl font-bold text-slate-100">Connect in two ways</h2>
          <div className="mt-4 space-y-4">
            <div className="rounded-lg border border-slate-800 bg-[#06080D] p-4">
              <div className="text-sm font-semibold text-slate-100">Web interface</div>
              <p className="mt-1 text-sm text-slate-400">Datacenter → Storage → Add → Proxmox Backup Server. We show exactly which field takes each value, with copy buttons.</p>
            </div>
            <div className="rounded-lg border border-slate-800 bg-[#06080D] p-4">
              <div className="text-sm font-semibold text-slate-100">CLI command</div>
              <pre className="mt-2 overflow-x-auto rounded bg-slate-950 p-3 font-mono text-xs text-cyan-300">pvesm add pbs zettakeep --server ...{"\n"}  --datastore zk-datastore --fingerprint ...</pre>
            </div>
          </div>
          <p className="mt-4 text-xs text-slate-500">ZettaKeep is an independent product and is not affiliated with Proxmox Server Solutions GmbH. Compatible with Proxmox VE and Proxmox Backup Server.</p>
        </div>
      </div>
      <div className="mt-10">
        <Link to="/signup" className="inline-flex items-center gap-2 rounded-lg bg-cyan-400 px-6 py-3 font-semibold text-[#06080D] hover:bg-cyan-300">Deploy My Backup Server <ArrowRight className="h-4 w-4" /></Link>
      </div>
    </div>
  );
}
